import React from 'react';

const ImageCard = ({ backgroundImage, text, className = '', onClick, ...props }) => {
  return (
    <div
      className={`relative rounded-xl overflow-hidden group cursor-pointer h-72 ${className}`}
      onClick={onClick}
      {...props}
    >
      {/* Background image container */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-700 ease-in-out group-hover:scale-110"
        style={{
          backgroundImage: `
            linear-gradient(0deg, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),
            linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.2) 100%),
            url("${backgroundImage}")
          `,
        }}
      />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-black/50 to-transparent" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end p-10">
        <div className="flex flex-row items-start">
          <div className="self-stretch bg-white w-0.5 h-full" />
          <p className="font-normal text-base leading-none text-white capitalize text-left ml-4">
            {text}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImageCard;
